<template>
  <v-container>
    <v-layout>
    <v-flex>
      <v-tooltip top >
      <v-btn
          class="mr-2 mb-2"
          @click="newProvider"
          color="customPurple"
          dark
          fixed
          bottom
          right
          fab
          slot="activator"
        >
          <v-icon>add</v-icon>
        </v-btn>
        <span>Crear Proveedor</span>
    </v-tooltip>
      <div>
        <v-layout>
          <v-flex xs12 sm6 offset-sm6>
            <v-text-field
              v-model="search"
              append-icon="search"
              label="Buscar"
              single-line
              hide-details
            ></v-text-field>
          </v-flex>
        </v-layout>
      </div>
    </v-flex>
      <v-dialog
        v-model="dialog"
        max-width="500px"
        transition="dialog-bottom-transition"
        scrollable>
        <v-card tile>
          <v-toolbar card dark color="nav_background_color">
            <v-btn icon dark @click.native="dialog = false" @click="cleanData">
              <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title>Crear nuevo Proveedor</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card-text>
            <v-form ref="form" v-model="valid" lazy-validation>
              <v-layout>
                <v-flex xs12 sm7 offset-sm1>
                  <v-text-field
                    name="codigo"
                    label="Código"
                    id="code"
                    :rules="[v => !!v || 'El código es requerido', v => (v && v.length <= 10) || 'El código debe tener menos de 10 caracteres']"
                    required
                    v-model="provider.code"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout>
                <v-flex xs12 sm10 offset-sm1>
                  <v-text-field
                    name="nombre"
                    label="Nombre"
                    id="nombre"
                    :rules="[v => !!v || 'Es requerido',v => (v && v.length <= 50) || 'El número de caracteres debe ser menor a 50']"
                    v-model="provider.name"
                    required
                    v-on:keyup.enter="saveData"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout>
                <v-flex xs12 sm10 offset-sm1>
                  <v-text-field
                          name="descrpcion"
                          label="Descripción"
                          id="description"
                          :rules="[v => !!v || 'Es requerido',v => (v && v.length <= 250) || 'El número de caracteres debe ser menor a 250']"
                          v-model="provider.description"
                          required
                          v-on:keyup.enter="saveData"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout>
                <v-flex xs12 sm6 offset-sm4>
                  <div>
                    <v-btn :disabled="!valid"
                           @click="saveData" large color="primary">Guardar</v-btn>
                  </div>
                </v-flex>
              </v-layout>
            </v-form>
          </v-card-text>
          <div style="flex: 1 1 auto;"></div>
        </v-card>
      </v-dialog>
    </v-layout>
       <h3 class="primary--text">Lista de Proveedores</h3>
      <v-data-table
        :headers="headers"
        :items="$store.state.providers"
        class="elevation-1"
        sort-icon="mdi-menu-down"
        :search="search"
      >
        <template slot="items" slot-scope="props">
          <td class="text-xs-left">{{ props.item.code }}</td>
          <td class="text-xs-left">{{ props.item.name }}</td>
          <td class="text-xs-left">{{ props.item.description }}</td>
          <td>
            <v-tooltip top >
              <v-btn 
              fab dark 
              small @click="editItem(props.item)" 
              slot="activator"
              color="primary">
              <v-icon dark>edit</v-icon>
            </v-btn>
            <span>Editar</span>
            </v-tooltip>
            <v-tooltip top >
              <v-btn fab dark small @click="deleteItem(props.item)" slot="activator" color="primary">
                <v-icon dark>delete</v-icon>
              </v-btn>
            <span>Eliminar</span>
            </v-tooltip>
          </td>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning">
           No se han encontrado resultados para "{{ search }}".
        </v-alert>
      </v-data-table>
  </v-container>
</template>
<script>
import Provider from "../../model/Provider";

export default {
  data() {
    return {
      search: '',
      valid: false,
      requiredField: [v => !!v || 'Es requerido'],
      dialog: false,
      headers: [
        { text: 'Código', value: 'code' },
        { text: 'Nombre', value: 'name' },
        { text: 'Descripción', value: 'description' }
      ],
      editedIndex: -1,
      provider: new Provider()
    };
  },
  methods: {
    cleanData() {
      this.$refs.form.reset();
      this.provider = new Provider();
      this.valid = false;
      this.dialog = false;
    },
    newProvider() {
      this.editedIndex = -1;
      this.valid = false;
      this.dialog = true;
      this.$refs.form.reset();
      this.provider = new Provider();
    },
    saveData() {
      if (this.$refs.form.validate()) {
        if (this.editedIndex > -1) {
          this.$store.dispatch('updateProvider', this.provider).then(
            response => {
              this.cleanData();
            },
            error => {
              this.$store.state.progress = false;
              this.$store.state.dialogError = true;
            }
          );
        } else {
          this.$store.dispatch('addProvider', this.provider).then(
            response => {
              this.cleanData();
            },
            error => {
              this.$store.state.progress = false;
              this.$store.state.dialogError = true;
            }
          );
        }
        this.dialog = false;
      }
    },
    editItem(item) {
      this.editedIndex = this.$store.state.providers.indexOf(item);
      this.provider = Object.assign({}, item);
      this.dialog = true;
    },
    deleteItem(item) {
      this.editedIndex = this.$store.state.providers.indexOf(item);
      this.provider = Object.assign({}, item);
      confirm('Está seguro de que quiere eliminar el registro?') &&
        this.$store.dispatch('deleteProvider', this.provider.id);
    }
  },
  computed: {},
  beforeCreate() {
    this.$store.dispatch('getProviders').then(
      response => {
        this.cleanData();
      },
      error => {
        this.$store.state.dialogError = true;
      }
    );
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/provider/Provider.vue